import { render, staticRenderFns } from "./plandoctordentist.vue?vue&type=template&id=02f10c78&scoped=true&"
import script from "./plandoctordentist.vue?vue&type=script&lang=js&"
export * from "./plandoctordentist.vue?vue&type=script&lang=js&"
import style0 from "./plandoctordentist.vue?vue&type=style&index=0&id=02f10c78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f10c78",
  null
  
)

export default component.exports